<h2 mat-dialog-title class="title-message">
  @if (isTosForm) {
    Play Octopus Terms of Service
  }
  @if (!isTosForm) {
    Warning
  }
</h2>
<mat-dialog-content>

  @if (isTosForm) {
    <div class="mb-2">
      <div class="checkbox">
        <label>
          <input
            id="agree"
            name="agree"
            type="checkbox"
            (click)="acceptTos()"
            />
          I agree to Play Octopus's
          <button
            type="button"
            class="btn-agreement-link p-0 change-email-link"
            (click)="showTermsModal()"
            >
            Terms of Service</button
            >*
          </label>
        </div>
      </div>
    } @else {
      <div class="mb-2">
        You must accept the Octopus's
        <a
          type="button"
          class="btn-agreement-link p-0 change-email-link"
          (click)="isTosForm = true"
          >
          Terms of Service</a
          >
          to proceed.
        </div>
      }
    </mat-dialog-content>
